import { render, staticRenderFns } from "./TolovTable.vue?vue&type=template&id=97656480"
import script from "./TolovTable.vue?vue&type=script&lang=js"
export * from "./TolovTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports